import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form, Icon, Button, Loader } from "semantic-ui-react";
import { TitleCase } from "../../common";
import ControlTitle from "../ControlTitle";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as AppActions from "../../actions";
import _ from "lodash";
import ReactModal from "react-modal";

const customStyles = {
  content: {
    top: "50%",
    maxWidth: "700px",
    width: "80%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: "0px;",
    borderRadius: "5px",
    backgroundColor: "transparent",
    height: "85%",
    border: "0px",
    transform: "translate(-50%, -50%)"
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)"
  }
};

String.prototype.replaceAll = function(find, replace) {
  var str = this;
  return str.replace(new RegExp(find, "g"), replace);
};

class AddressSearch extends Component {
  constructor() {
    super();
    this.state = {
      LookupData: [],
      selectedValue: "",
      key: "",
      optionsData: [],
      gotLookup: false,
      visible: false,
      loading: false,
      Start: true,
      filterText: "",
      cancel: false,
      showFields: false,
      address_line1: "",
      address_line2: "",
      address_line3: "",
      address_line4: "",
      address_line5: ""
    };
  }

  componentWillMount() {
    const { ...formControl } = this.props;
    this.setState({
      key: formControl.element_params.K,
      selectedValue: this.props.element_value
    });
  }

  getPCA(address) {
    let i = 0;
    let aAddress = address.split(",");
    let num = aAddress.length;

    for (let i = 0; i < 4; i++) {
      if (i >= num - 1) {
        this.setState({ ["address_line" + (i + 1).toString()]: "" });
      } else {
        this.setState({ ["address_line" + (i + 1).toString()]: aAddress[i] });
      }
    }

    this.setState({ ["address_line5".toString()]: aAddress[num - 1] });
  }

  handleChange(d, e) {
    this.setState({ filterText: "" });
    var lookupItem = [];

    lookupItem = _.filter(this.state.LookupData, { Id: d });

    var objItem = lookupItem[0];
    if (objItem.Type !== "Address") {
      this.searchDirect("", objItem.Id);
    } else {
      let address = TitleCase(objItem.Text + ", " + objItem.Description);

      this.getPCA(address);

      this.setState({
        visible: false,
        showFields: true,
        selectedValue: address
      });

      this.props.onChange(
        this.props.repeatingForm,
        this.props.element_id,
        address
      );
    }
  }

  handleCancel() {
    this.setState({ cancel: true });
    this.forceUpdate();
    this.handleClose();
  }

  handleClear() {
    if (this.state.loading) {
      this.handleCancel();
    } else {
      this.setState({
        selectedValue: "",
        address_line1: "",
        address_line2: "",
        address_line3: "",
        address_line4: "",
        address_line5: ""
      });
      this.props.onChange(this.props.repeatingForm, this.props.element_id, "");
    }
  }

  searchDirect(e, Id) {
    if (this.state.selectedValue.trim() === "") {
      return;
    }

    this.setState({ loading: true, cancel: false });
    this.forceUpdate();

    let initialLookupData = [];

    let ft = encodeURI(this.state.selectedValue);
    let ct = "";
    if (Id.as !== "button") {
      ct = "&Container=" + encodeURI(Id);
    }

    let notAddress = false;

    return fetch(
      "https://api.addressy.com/Capture/Interactive/Find/v1.00/json3.ws?Key=" +
        this.state.key +
        "&Text=" +
        ft +
        ct +
        "&Countries=GB&Limit=1000&Language=",
      {
        method: "GET"
      }
    )
      .then(function(response) {
        var json = response.json();
        return json;
      })
      .then(data => {
        if (!this.state.cancel) {
          if (data.Items === null) {
            initialLookupData = [];
          } else {
            initialLookupData = data.Items.map(lookup => {
              return lookup;
            });

            if (initialLookupData.length === 1) {
              if (initialLookupData[0].Type !== "Address") {
                this.searchDirect("", initialLookupData[0].Id);
                notAddress = true;
              }
            }
          }

          if (!notAddress) {
            var optionsDataInit = [];
            initialLookupData.forEach(element => {
              optionsDataInit.push({
                label: TitleCase(element.Text + ", " + element.Description),
                key: element.Id
              });
            });

            this.setState({
              visible: true,
              loading: false,
              optionsData: optionsDataInit,
              LookupData: initialLookupData,
              gotLookup: true
            });
          }
        }
      })
      .catch(function() {
        this.setState({ loading: false });
      });
  }

  renderSearchButton() {
    if (this.state.loading) {
      return (
        <Button
          className="ui active button"
          style={{ height: "40px", width: "46px", position: "absolute" }}
          icon
          onClick={this.searchDirect.bind(this)}
        >
          <Loader
            active
            inverted
            style={{ position: "relative", top: "9px" }}
            size="small"
          />
        </Button>
      );
    }
    return (
      <Button
        className="ui active button"
        style={{ height: "40px", width: "46px", position: "absolute" }}
        icon
        onClick={this.searchDirect.bind(this)}
      >
        <Icon name="search" />
      </Button>
    );
  }

  renderDropdownArrow() {
    const { validate, error } = this.props;

    if (validate && error) {
      if (this.state.Start) {
        return (
          <span style={{ float: "left", width: "100%", paddingRight: "55px" }}>
            <input
              type="text"
              className="error"
              style={{ float: "left" }}
              value={
                this.props.isConnected
                  ? this.state.selectedValue
                      .replaceAll(",,,", ",")
                      .replaceAll(",,", ",")
                  : ""
              }
              onChange={value => this.handleTextChange(value)}
            />
            {this.renderSearchButton()}
          </span>
        );
      }

      return (
        <span style={{ float: "left", width: "100%", paddingRight: "55px" }}>
          <input
            type="text"
            className="error"
            style={{ float: "left" }}
            value={
              this.props.isConnected
                ? this.state.selectedValue
                    .replaceAll(",,,", ",")
                    .replaceAll(",,", ",")
                : ""
            }
            onChange={value => this.handleTextChange(value)}
          />
          {this.renderSearchButton()}
        </span>
      );
    }

    if (this.state.Start) {
      return (
        <span style={{ float: "left", width: "100%", paddingRight: "55px" }}>
          <input
            type="text"
            placeholder={
              this.props.isConnected
                ? ""
                : "Offline: Address search not available"
            }
            style={{ float: "left" }}
            value={
              this.props.isConnected
                ? this.state.selectedValue
                    .replaceAll(", ", ",")
                    .replaceAll(",,,", ",")
                    .replaceAll(",,", ",")
                    .replaceAll(",", ", ")
                : ""
            }
            onChange={value => this.handleTextChange(value)}
          />
          {this.renderSearchButton()}
        </span>
      );
    }

    return (
      <span style={{ float: "left", width: "100%", paddingRight: "55px" }}>
        <input
          type="text"
          placeholder={
            this.props.isConnected
              ? ""
              : "Offline: Address search not available"
          }
          style={{ float: "left" }}
          value={
            this.props.isConnected
              ? this.state.selectedValue
                  .replaceAll(", ", ",")
                  .replaceAll(",,,", ",")
                  .replaceAll(",,", ",")
                  .replaceAll(",", ", ")
              : ""
          }
          onChange={value => this.handleTextChange(value)}
        />
        {this.renderSearchButton()}
      </span>
    );
  }

  handleTextChange(value) {
    this.setState({ selectedValue: value.target.value });
  }

  renderPCA() {
    const { validate, error, ...formControl } = this.props;

    if (this.state.showFields || !this.props.isConnected) {
      let address = [];
      for (let index = 0; index < 4; index++) {
        if (
          validate &&
          error &&
          index === 0 &&
          this.state["address_line" + (index + 1)].toString() === ""
        ) {
          address.push(
            <Form.Field>
              <ControlTitle
                text={"Address Line " + (index + 1).toString()}
                optional={
                  index === 0 && formControl.element_optional === "0"
                    ? false
                    : true
                }
              ></ControlTitle>
              <div>
                <input
                  type="text"
                  className="error"
                  value={this.state[
                    "address_line" + (index + 1).toString()
                  ].trimStart()}
                  onChange={this.handleFieldChange.bind(this, index + 1)}
                />
              </div>
            </Form.Field>
          );
        } else {
          address.push(
            <Form.Field>
              <ControlTitle
                text={"Address Line " + (index + 1).toString()}
                optional={
                  index === 0 && formControl.element_optional === "0"
                    ? false
                    : true
                }
              ></ControlTitle>
              <div>
                <input
                  type="text"
                  value={this.state[
                    "address_line" + (index + 1).toString()
                  ].trimStart()}
                  onChange={this.handleFieldChange.bind(this, index + 1)}
                />
              </div>
            </Form.Field>
          );
        }
      }

      if (validate && error && this.state.address_line5 === "") {
        address.push(
          <Form.Field>
            <ControlTitle
              text={"Post Code"}
              optional={formControl.element_optional === "0" ? false : true}
            ></ControlTitle>
            <div>
              <input
                type="text"
                className="error"
                value={this.state.address_line5.trimStart()}
                onChange={this.handleFieldChange.bind(this, 5)}
              />
            </div>
          </Form.Field>
        );
      } else {
        address.push(
          <Form.Field>
            <ControlTitle
              text={"Post Code"}
              optional={formControl.element_optional === "0" ? false : true}
            ></ControlTitle>
            <div>
              <input
                type="text"
                value={this.state.address_line5.trimStart()}
                onChange={this.handleFieldChange.bind(this, 5)}
              />
            </div>
          </Form.Field>
        );
      }

      return <div>{address}</div>;
    }

    return null;
  }

  handleClose() {
    this.setState({ visible: false, loading: false, filterText: "" });
  }

  handleShow() {
    if (!this.state.showFields) {
      this.setState({ showFields: true });
    } else {
      this.setState({ showFields: false });
    }
  }

  getAddressItems() {
    let addressItems = [];
    let h = window.innerHeight * 0.85 - 70 - 44;

    let filterString = this.state.filterText;

    this.state.optionsData.forEach(element => {
      if (
        element.label.toLowerCase().indexOf(filterString.toLowerCase()) !==
          -1 ||
        filterString === ""
      ) {
        addressItems.push(
          <div
            onClick={this.handleChange.bind(this, element.key)}
            className="rows"
          >
            {element.label}
          </div>
        );
      }
    });

    return (
      <div
        style={{
          width: "100%",
          height: h + "px",
          overflowY: "auto",
          borderBottomLeftRadius: "5px",
          borderBottomRightRadius: "5px",
          backgroundColor: "rgb(230, 230, 230)"
        }}
      >
        {addressItems}
      </div>
    );
  }

  formatAddress(i, value) {
    let address = "";
    for (let index = 0; index < 5; index++) {
      if (index === i) {
        address += index > 0 ? "," + value : value;
      } else {
        address +=
          index > 0
            ? "," + this.state["address_line" + (index + 1).toString()]
            : this.state["address_line" + (index + 1).toString()];
      }
    }

    return address;
  }

  handleFieldChange(index, e) {
    let value = e.target.value;
    this.setState({ ["address_line" + index.toString()]: value });

    let address = this.formatAddress(index - 1, value);
    let aAddress = address.split(",");
    if (aAddress[0] === "" || aAddress[4] === "") {
      address = "";
    }
    this.setState({ selectedValue: address });
    this.props.onChange(
      this.props.repeatingForm,
      this.props.element_id,
      address
    );
  }

  handleFilter(e) {
    let fd = "";
    this.setState({ filterText: e.target.value });
  }

  renderSelect() {
    return (
      <div style={{ maxWidth: 500 }}>
        <div>
          <form
            onSubmit={e => {
              this.searchDirect.bind(this);
              e.preventDefault();
            }}
          >
            {this.renderDropdownArrow()}
          </form>
        </div>
        <div style={{ width: "100%", height: 50, marginBottom: 30 }}>
          <span
            onClick={this.handleShow.bind(this)}
            style={{
              marginLeft: 3,
              textDecorationLine: "underline",
              lineHeight: "30px",
              cursor: "pointer",
              color: this.props.storeColour.mainBgColor
            }}
          >
            {this.state.showFields
              ? "Hide Address Fields"
              : "Enter Address Manually"}
          </span>
          <span
            onClick={this.handleClear.bind(this)}
            style={{
              float: "right",
              visibility: this.props.isConnected ? "visible" : "hidden",
              textDecorationLine: "underline",
              lineHeight: "30px",
              cursor: "pointer",
              color: this.props.storeColour.mainBgColor,
              marginRight: "60px"
            }}
          >
            {this.state.loading ? "Cancel" : "Clear"}
          </span>
        </div>
        {this.renderPCA()}
        <ReactModal
          isOpen={this.state.visible}
          style={customStyles}
          contentLabel="Example Modal"
          onRequestClose={() => {}}
        >
          <div
            className="hrl"
            style={{
              width: "100%",
              height: "44px",
              lineHeight: "44px",
              backgroundColor: "white"
            }}
          >
            <div
              style={{
                paddingLeft: "0px",
                paddingTop: "5px",
                marginBottom: "0px",
                paddingBottom: "0px"
              }}
              className="ui form formControlItem"
            >
              <Form.Field>
                <input
                  type="text"
                  style={{ border: "none" }}
                  onChange={this.handleFilter.bind(this)}
                  value={this.state.filterText}
                  placeholder="Filter..."
                />
              </Form.Field>
            </div>
          </div>
          {this.getAddressItems()}
          <div style={{ textAlign: "center", width: "100%", height: "50px" }}>
            <button
              onClick={this.handleClose.bind(this)}
              className="ui button submit"
              style={{ position: "relative", width: "100px", bottom: "-30px" }}
              role="button"
            >
              Cancel
            </button>
          </div>
        </ReactModal>
      </div>
    );
  }

  onShow = () => {
    this.setState({ visible: true });
  };

  onSelect = picked => {
    this.handleChange("", picked);
  };

  onCancel = () => {
    this.setState({
      visible: false
    });
  };

  render() {
    const { element_prompt, element_value, ...formControl } = this.props;

    return (
      <div className="formControlItem">
        <Form.Field>
          <ControlTitle
            text={element_prompt}
            optional={formControl.element_optional === "1" ? true : false}
          ></ControlTitle>
          {this.renderSelect()}
        </Form.Field>
      </div>
    );
  }
}

AddressSearch.propTypes = {
  element_prompt: PropTypes.string.isRequired,
  element_value: PropTypes.string.isRequired,
  element_id: PropTypes.number.isRequired,
  error: PropTypes.bool.isRequired,
  validate: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  sessionId: PropTypes.string
};

const mapStateToProps = state => ({
  deviceId: state.informedWebApp.deviceId,
  username: state.informedWebApp.username,
  password: state.informedWebApp.password,
  isConnected: state.informedWebApp.isConnected,
  datasource: state.forms.datasource,
  api: state.informedWebApp.api,
  storeColour: state.informedWebApp.storeColour,
  lookupData: state.forms.lookupData
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddressSearch);



// WEBPACK FOOTER //
// ./src/components/AddressSearch/index.js